import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgMapGet',
  standalone: false,
})
export class SgMapGetPipe implements PipeTransform {
  transform<T, Z = any>(map: Map<T, Z>, key: T, defaultValue?: Z): Z {
    if (map.has(key)) {
      return map.get(key);
    } else {
      return defaultValue;
    }
  }
}

@Pipe({
  name: 'sgObjectGet',
  standalone: false,
})
export class SgObjectGetPipe implements PipeTransform {
  transform<O, T extends keyof O>(obj: O, key: T, defaultValue?: O[T] | undefined): O[T] | undefined {
    const value = obj[key];
    if (typeof value === 'undefined') {
      return defaultValue;
    } else {
      return value;
    }
  }
}
